/*
 * Configuration for Keycloak OAuth authentication (Identity Broker)
 * Based on OpenID Connect specification
 *
 * Keycloak acts as an identity broker, allowing users to authenticate
 * via Microsoft or Google through Keycloak's identity brokering feature.
 *
 * Prerequisites (server-side):
 * - Identity brokering configured for Microsoft and/or Google
 * - "Store Tokens" enabled in the IDP settings
 * - Token exchange enabled in the realm
 * - Claim 'idp' included in tokens
 */

import { TARGET_API_V2 } from "../../../managers";

export type OAuthConfig = {
    authority: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    scopes: string[];
};

const BASE_CONFIG: Omit<OAuthConfig, "authority"> = {
    clientId: "web",
    redirectUri: "/dashboard",
    postLogoutRedirectUri: "/",
    scopes: ["openid", "profile", "email"],
};

const PROD_CONFIG: OAuthConfig = {
    ...BASE_CONFIG,
    authority: "https://auth.mailvista.ai/realms/mailvista",
};

const DEV_CONFIG: OAuthConfig = {
    ...BASE_CONFIG,
    authority:
        "https://test-keyk.victoriousplant-ba9c38fc.francecentral.azurecontainerapps.io/realms/mailvista",
};

export const OAUTH_CONFIG: Record<TARGET_API_V2, OAuthConfig> = {
    [TARGET_API_V2.Api_Prod]: PROD_CONFIG,
    [TARGET_API_V2.Api_Recette]: DEV_CONFIG,
    [TARGET_API_V2.Api_Dev]: DEV_CONFIG,
    [TARGET_API_V2.Api_Local]: DEV_CONFIG,
};
